import { apiHelper } from "./api_helper";

export const SALESET_REGISTER_TYPE_API_ENDPOINT = 'saleset-register-type';
export const saleSetRegisterTypeApi = {
    SelectAll: () => apiHelper.get(`${SALESET_REGISTER_TYPE_API_ENDPOINT}`),
    SelectByHocSinh: (ts_hocsinh_id) => apiHelper.get(`${SALESET_REGISTER_TYPE_API_ENDPOINT}/select-by-hs/${ts_hocsinh_id}`),

}